import { useQuery } from "@tanstack/react-query";
import { getScoringAndRank } from "../../../api";
import { useCurrentGameId } from "./use-current-game";

export function useCurrentScoringAndRank() {
  const gameId = useCurrentGameId();

  return useQuery({
    queryKey: ["games", gameId, "scoring-and-rank"],
    queryFn: async () => {
      return await getScoringAndRank(gameId);
    },
    enabled: !!gameId,
  });
}
